import React from 'react';
import {
  Dashboard as DashboardIcon,
  ShoppingCart as VentasIcon,
  Store as ComprasIcon,
  Inventory as InventarioIcon,
  AccountBalance as TesoreriaIcon,
  Category as CategoryIcon,
  SwapHoriz as SwapHorizIcon,
  ListAlt as ListAltIcon,
  QuestionAnswer as ConsultasIcon,
  Assessment as AssessmentIcon,
  Receipt as ReceiptIcon,
  Payment as PaymentIcon,
  MenuBook as MenuBookIcon,
  AccountTree as AccountTreeIcon,
  Schema as SchemaIcon,
  PriceChange as PriceChangeIcon,
  Route as RouteIcon,
} from '@mui/icons-material';

export interface NavigationMenuItem {
  text: string;
  icon: React.ReactNode;
  path: string;
  subItems?: NavigationMenuItem[];
}

export const navigationMenuItems: NavigationMenuItem[] = [
  { text: 'Indicadores', icon: <DashboardIcon />, path: '/dashboard' },
  {
    text: 'Ventas',
    icon: <VentasIcon />,
    path: '/ventas',
    subItems: [
      { text: 'Cotizaciones', icon: <ListAltIcon />, path: '/ventas/cotizaciones' },
      { text: 'Pedidos', icon: <ListAltIcon />, path: '/ventas/pedidos' },
      { text: 'Facturas', icon: <ListAltIcon />, path: '/ventas/facturas' },
      { text: 'Remitos', icon: <ListAltIcon />, path: '/ventas/remitos' },
      { text: 'Notas de Crédito', icon: <ListAltIcon />, path: '/ventas/notas-credito' },
      { text: 'Plan de visitas', icon: <RouteIcon />, path: '/ventas/visitas' },
      { text: 'Recibos de cobranza', icon: <ReceiptIcon />, path: '/tesoreria/recibos' },
      { text: 'Informes', icon: <AssessmentIcon />, path: '/ventas/informes' },
      { text: 'Clientes', icon: <CategoryIcon />, path: '/ventas/clientes' },
      { text: 'Consulta IA Ventas', icon: <ConsultasIcon />, path: '/ventas/consultas-ia' },
    ],
  },
  {
    text: 'Compras',
    icon: <ComprasIcon />,
    path: '/compras',
    subItems: [
      { text: 'Órdenes de Compra', icon: <ListAltIcon />, path: '/compras/ordenes' },
      { text: 'Remitos de Compra', icon: <ListAltIcon />, path: '/compras/remitos' },
      { text: 'Facturas de Compra', icon: <ReceiptIcon />, path: '/compras/facturas' },
      { text: 'Órdenes de pago', icon: <PaymentIcon />, path: '/tesoreria/orden-pago' },
      { text: 'Notas de Crédito', icon: <ListAltIcon />, path: '/compras/notas-credito' },
      { text: 'Informes', icon: <AssessmentIcon />, path: '/compras/informes' },
      { text: 'Proveedores', icon: <CategoryIcon />, path: '/compras/proveedores' },
      { text: 'Ramos de Proveedores', icon: <CategoryIcon />, path: '/compras/ramosprov' },
      { text: 'Consulta IA Compras', icon: <ConsultasIcon />, path: '/compras/consultas-ia' },
    ],
  },
  {
    text: 'Inventario',
    icon: <InventarioIcon />,
    path: '/inventario',
    subItems: [
      { text: 'Ajustes y Transf.', icon: <SwapHorizIcon />, path: '/inventario/transferencias' },
      { text: 'Informes', icon: <AssessmentIcon />, path: '/inventario/informes' },
      { text: 'Mantenimiento de precios', icon: <PriceChangeIcon />, path: '/inventario/mantenimiento-precios' },
      { text: 'Productos', icon: <CategoryIcon />, path: '/inventario/productos' },
      { text: 'Ramos', icon: <CategoryIcon />, path: '/inventario/ramos' },
      { text: 'Líneas', icon: <CategoryIcon />, path: '/inventario/lineas' },
      { text: 'Clases', icon: <CategoryIcon />, path: '/inventario/clases' },
      { text: 'Consulta IA Inventario', icon: <ConsultasIcon />, path: '/inventario/consultas-ia' },
    ],
  },
  {
    text: 'Tesorería',
    icon: <TesoreriaIcon />,
    path: '/tesoreria',
    subItems: [
      { text: 'Planilla de Caja', icon: <ReceiptIcon />, path: '/tesoreria/movimientos-caja' },
      { text: 'Recibos de cobranza', icon: <ListAltIcon />, path: '/tesoreria/recibos' },
      { text: 'Orden de Pago', icon: <ListAltIcon />, path: '/tesoreria/orden-pago' },
      { text: 'Traspasos', icon: <SwapHorizIcon />, path: '/tesoreria/transferencias' },
      { text: 'Movimientos Varios', icon: <ListAltIcon />, path: '/tesoreria/movimientos-varios' },
      { text: 'Movimientos Bancarios', icon: <ListAltIcon />, path: '/tesoreria/movimientos-bancarios' },
      { text: 'Conciliación Bancaria', icon: <ListAltIcon />, path: '/tesoreria/conciliacion-bancaria' },
      { text: 'Informes', icon: <AssessmentIcon />, path: '/tesoreria/informes' },
      { text: 'Consulta IA Tesorería', icon: <ConsultasIcon />, path: '/tesoreria/consultas-ia' },
    ],
  },
  {
    text: 'Contabilidad',
    icon: <MenuBookIcon />,
    path: '/contabilidad',
    subItems: [
      { text: 'Asientos / Libro diario', icon: <ListAltIcon />, path: '/contabilidad/asientos-diario' },
      { text: 'Libro mayor', icon: <AccountTreeIcon />, path: '/contabilidad/libro-mayor' },
      { text: 'Plan de cuentas', icon: <SchemaIcon />, path: '/contabilidad/plan-cuentas' },
      {
        text: 'Informes',
        icon: <AssessmentIcon />,
        path: '/contabilidad/informes',
        subItems: [
          { text: 'Estado de resultados', icon: <AssessmentIcon />, path: '/contabilidad/estado-resultados' },
          { text: 'Situación patrimonial', icon: <AssessmentIcon />, path: '/contabilidad/situacion-patrimonial' },
        ],
      },
      { text: 'Estrategias', icon: <CategoryIcon />, path: '/contabilidad/estrategia' },
    ],
  },
];
